export default __webpack_public_path__ + "static/media/hotel_100px.1dab2109.svg";